import * as Errors from './errors.json';
import { TError, TErrorDescription } from './types';

const ErrorsDescription: TErrorDescription = Object.keys(Errors as TError).reduce(
    (acc: TErrorDescription, currentValue: string) => {
        const currentErrorCode = Errors[currentValue as keyof typeof Errors];
        acc[currentErrorCode] = currentValue;
        return acc;
    },
    {}
);

export { TError, TErrorDescription, Errors, ErrorsDescription };

